import { Component, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { AppConfigService } from '@core/appconfig.service';
import { ViewerAssetType } from '@shared/enums/viewer-asset';


import { ViewerBaseComponent } from '../viewer-shared/viewer-base.component';
import { ViewerService } from '../viewer.service';

@Component({
  selector: 'zbp-viewer-iframe',
  templateUrl: './viewer-iframe.component.html',
  styleUrls: ['./viewer-iframe.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: []
})
export class ViewerIFrameComponent extends ViewerBaseComponent implements OnChanges {
  iframeUri: SafeResourceUrl;

  private ilbPlayerPath = 'sites/ilbplayer/index.html';
  private bookUrl: string;
  private pronunciationBaseUrl: string;

  constructor(
    private appConfigService: AppConfigService,
    private sanitizer: DomSanitizer,
    private viewerService: ViewerService) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.bookUrl = `?bookUrl=${this.appConfigService.assetUrl}content/ilb`;
    this.pronunciationBaseUrl = `&pronunciationBaseUrl=${this.appConfigService.assetUrl}content/ilb/bookwords&autoEnd=true`;
    if (changes.asset) {
      this.setAssetSource();
    }
  }

  onLoad(): void {
    setTimeout(() => {
      this.loaded.emit();
    }, 0);
  }

  private setAssetSource(): void {
    const uri = this.parseAssetUrl();

    if (uri) {
      this.iframeUri = this.sanitizer.bypassSecurityTrustResourceUrl(uri);
    } else {
      this.withError.emit('Unable to load application');
    }
  }

  private parseAssetUrl(): string {
    let uri: string = null;
    const { assetId } = this.asset;

    if (this.asset.viewerAssetType === ViewerAssetType.SuperSmart) {
      uri = this.viewerService.getAssetFilenameUrl(this.asset, `supersmart/${assetId}`);
    } else if (this.asset.viewerAssetType === ViewerAssetType.Iwb) {
      uri = this.viewerService.getAssetFilenameUrl(this.asset, `iwb/${assetId}`);
    } else if (this.asset.viewerAssetType === ViewerAssetType.Ilb) {
      const fileNameParts = this.asset.fileName.split('#');
      const fileName = fileNameParts.shift();
      const sectionId = fileNameParts.pop();
      uri = `${this.appConfigService.assetUrl}${this.ilbPlayerPath}${this.bookUrl}/${fileName}${this.pronunciationBaseUrl}`;
      if (fileName !== sectionId) {
        uri += `&sectionId=${sectionId}`;
      }
    }

    return uri;
  }
}
